module.exports = __webpack_public_path__ + "static/media/file-pdf.1c6b2025.svg";